import gql from 'graphql-tag';

export const SaveContractorServiceZipMutation = gql`
  mutation ($contractServiceZip: ContractorServiceZipInput!) {
    saveContractorServiceZip (contractServiceZip: $contractServiceZip)
    {
      id,
      name,
      _Ebb_ContactId,
      zipCode
    }
  }
`;
export const DeleteContractorServiceZipMutation = gql`
  mutation ($contractServiceZip: ContractorServiceZipInput!) {
    deleteContractorServiceZip (contractServiceZip: $contractServiceZip)
    {
      id,
      name,
      _Ebb_ContactId,
      zipCode
    }
  }
`;
